/**
 * Display indexes for two accounting lenses. Each series is normalized to its
 * own baseline. This is not an emissions formula and does not combine totals.
 */

export interface IndexedPoint {
  year: number;
  index: number | null;
}

export function indexToBaseline(
  points: Array<{ year: number; value: number | null }>,
  baselineYear: number
): { points: IndexedPoint[]; suppressed: boolean; reason?: string } {
  const base = points.find((p) => p.year === baselineYear)?.value;
  if (base == null || !(base > 0)) {
    return { points: [], suppressed: true, reason: `No positive baseline value for ${baselineYear}` };
  }
  return {
    points: points.map((p) => ({
      year: p.year,
      index: p.value != null && Number.isFinite(p.value) ? (p.value / base) * 100 : null,
    })),
    suppressed: false,
  };
}

export function overlappingYears(
  a: Array<{ year: number; value: number | null }>,
  b: Array<{ year: number; value: number | null }>
): number[] {
  const ok = (v: number | null | undefined) => v != null && Number.isFinite(v);
  const yearsB = new Set(b.filter((p) => ok(p.value)).map((p) => p.year));
  return a.filter((p) => ok(p.value) && yearsB.has(p.year)).map((p) => p.year);
}
